import { SET_SEARCH, RESET_SEARCH, SECOND_STEP_DETAILS,SET_PROFILE_DATA,INTRO_DETAILS, SUBMISSION_DATA, SET_CATEGORY } from "../Actions/types";

const initialSearchByField = {
  preferred_location: [],
  area_of_interest: [],
  gradDegree: [],
  postGradCollege: [],
  postGradDegree: [],
  postGradSpecialization:[],
  undergradCollege: [],
  undergradUniversity: [],
  undergradDegree: [],
  underGradSpecialization: [],
  classTenth: [],
  classTwelfth: [],
  classTwelfthStream: [],
  skillSetList: [],
  homeCity: [],
  knownLanguages: [],
  lastWorkexDomain: [],
  lastWorkexIndustry: [],
  locationFilter: [],
  companyFilter: [],
};

const initialState = {
  searchByField: initialSearchByField,
  SecondStepData: {},
  profileData: [],
  introData:[],
  submissionData:{},
  categoryList: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_SEARCH: {
      const results = action.payload || {};
      const context = action.context || {};
      if (!context) return state;

      return {
        ...state,
        searchByField: {
          ...state.searchByField,
          [context]: Array.isArray(results) ? results : [],
        },
      };
    }

    case SECOND_STEP_DETAILS: {
      return { ...state, SecondStepData: action.payload };
    }
    case INTRO_DETAILS: {
      return { ...state, introData: action.payload };
    }
    case SET_PROFILE_DATA: {
      return { ...state, profileData: action.payload };
    }
    case SET_CATEGORY: {
      return { ...state, categoryList: action.payload };
    }
    case SUBMISSION_DATA: {
      return { ...state, submissionData: action.payload };
    }

    case RESET_SEARCH: {
      const { context } = action.payload || {};

      if (!context) {
        return {
          ...state,
          searchByField: initialSearchByField,
        };
      }

      return {
        ...state,
        searchByField: {
          ...state.searchByField,
          [context]: [],
        },
      };
    }

    default:
      return state;
  }
}
